<template>
  <div class="landing">
    <template v-if="!getHomeInLanding">
      <header>
        <a :href="`https://www.musement.com/${$ml.current}/`" target="_blank">
          <img
            :src="`${baseUrl}assets/images/musement-logo.svg`"
            alt="musement logo"
          />
        </a>
      </header>
      <div
        class="hero"
        :style="{
          backgroundImage: `url('${baseUrl}assets/images/hero${
            $retina ? '@2x' : ''
          }.jpg')`
        }"
      >
        <h1>{{ content.title }}</h1>
        <router-link :to="{ name: 'home' }">
          <button class="button-primary-hero">
            {{ content.primary_button }}
          </button></router-link
        >
        <div class="hero-gradient"></div>
      </div>
      <section class="intro">
        <h2 class="overline-text">{{ content.overline_text }}</h2>
        <div
          class="paragraph"
          v-html="formatDescription(content.description)"
        ></div>
        <img
          class="arrow"
          :src="
            `${baseUrl}assets/images/atoms-icons-actions-navigation-chevron-down.svg`
          "
        />
        <SocialSharing v-if="$tvaMq === 'desktop' || $tvaMq === 'large'" />
      </section>
    </template>
    <section
      :class="['home', { full: getHomeInLanding }]"
      ref="sectionHome"
      :style="{
        top: homeTopMargin + 'px',
        height: homeHeight ? homeHeight : '700px'
      }"
    >
      <transition name="widget">
        <template v-if="!getHomeInLanding">
          <WidgetOverlay />
        </template>
      </transition>
      <Home context="landing" :status="getHomeInLanding ? '' : 'collapsed'" />
    </section>
    <footer v-if="!getHomeInLanding">
      <div class="source">
        <a href="https://it.wikipedia.org/wiki/Raffaello_Sanzio#Opere">{{
          content.source.split("-")[0]
        }}</a>
        &nbsp;-&nbsp;
        <a href="https://commons.wikimedia.org/wiki/Template:PD-Art"
          >{{ content.source.split("-")[1] }} }}</a
        >
      </div>
      <div class="lang-switcher">
        <div class="lang-title">{{ content.dida_lang_switcher }}</div>

        <Dropdown
          :current="contentUrls[$ml.current].labels[$ml.current]"
          :itemAmount="$ml.list.length"
        >
          <li v-for="lang in $ml.list" :key="lang">
            <a :href="`https://www.musement.com/${contentUrls[lang].url}`">{{
              contentUrls[$ml.current].labels[lang]
            }}</a>
          </li>
        </Dropdown>
      </div>
      <SocialSharing
        class="mobile"
        v-if="$tvaMq === 'mobile' || $tvaMq === 'tablet'"
      />
      <div class="licence">
        <div
          class="licence-item"
          v-for="footer in splitFooter(content.footer)"
          :key="footer"
        >
          {{ footer }}
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import contentUrls from "@/assets/content/content-urls.json";
import Home from "@/views/Home.vue";
import WidgetOverlay from "@/components/WidgetOverlay.vue";
import Dropdown from "@/components/Dropdown.vue";
import SocialSharing from "@/components/SocialSharing.vue";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "landing",
  computed: {
    content() {
      return this.$ml.get("content");
    },
    ...mapGetters(["getHomeInLanding"])
  },
  watch: {
    getHomeInLanding(getHomeInLanding) {
      if (getHomeInLanding) {
        let homeSection = this.$refs.sectionHome;
        let initialTop = homeSection.getBoundingClientRect().top;
        let initialHeight = homeSection.getBoundingClientRect().height;
        this.homeTopMargin = initialTop;
        this.homeHeight = initialHeight + "px";
        setTimeout(() => {
          this.homeTopMargin = 0;
          this.homeHeight = "100vh";
        });
      } else {
        this.homeHeight = "700px";
      }
    }
  },
  methods: {
    formatDescription(string) {
      let splitted = string.split("[");
      let res = [];
      _.forEach(splitted, (splittedElem, index) => {
        let link = this.$ml.get("content")[`museum_${index - 1}`];
        if (index === 0) res.push(splittedElem);
        if (index > 0) {
          res.push(
            `<a href="${link}" target="_blank">${splittedElem.replace(
              "]",
              "</a>"
            )}`
          );
        }
      });
      return res.join(" ");
    },
    splitFooter(string) {
      return string.split("/");
    }
  },
  data() {
    return {
      homeHeight: null,
      homeTopMargin: 0,
      contentUrls,
      baseUrl: process.env.BASE_URL
    };
  },
  components: {
    Home,
    WidgetOverlay,
    Dropdown,
    SocialSharing
  }
};
</script>

<style lang="scss" scoped>
.landing {
  header {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 28px;
    }
  }
  .hero {
    padding: 0 15px;
    background-size: cover;
    background-position: 50% 50%;
    max-height: 500px;
    height: calc(100vh - 100px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    h1 {
      position: relative;
      z-index: 1;
      text-transform: uppercase;
      @include h1-desktop;
    }
    a {
      z-index: 1;
      .button-primary-hero {
      }
    }

    &-gradient {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to bottom,
        rgba(115, 63, 32, 0.27) 2%,
        rgba(25, 17, 13, 0.75)
      );
    }
  }
  .intro {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 15px;

    .overline-text {
      text-transform: uppercase;
      margin: 0;
      margin-top: 50px;
      @include overline-desktop;
    }
    .paragraph {
      @include p-desktop;
      margin-top: 30px;
      max-width: 702px;
      @media (max-width: 870px) {
        max-width: 550px;
      }
    }
    .arrow {
      margin: 23px 0 32px;
    }
  }
  .home {
    width: 100%;
    position: relative;
    transition: all 1s ease;
    // fade
    .widget-enter,
    .widget-leave-to {
      opacity: 0;
    }
    .widget-enter-to,
    .widget-leave {
      opacity: 1;
    }
    .widget-enter-active,
    .widget-leave-active {
      transition: opacity 10s ease;
    }
    &.full {
      position: fixed;
      left: 0;
    }
  }
  footer {
    .source {
      @include dida-small-UI_gray_4;
      padding: 27px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: solid 1px $ui-gray-3;
      a {
        color: $ui-gray-4 !important;
      }
    }
    .lang-switcher {
      margin-top: 27px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      width: 260px;
      margin: 26px auto 100px;
      .lang-title {
        font-family: Avenir;
        font-size: 12px;
        font-weight: 900;
        color: $ui-gray-4;
        margin-bottom: 5px;
      }
    }
    .licence {
      @include link-small-UI_gray_4;
      display: flex;
      justify-content: center;
      margin: 28px 0;
      .licence-item {
        margin-right: 10px;
        &::last-of-type {
          margin: 0;
        }
      }
    }
  }

  @media (max-width: $mobile-breakpoint) {
    header {
      height: 50px;
      img {
        height: 20px;
      }
    }
    footer {
      .lang-switcher {
        margin-bottom: 50px;
      }
      .licence {
        flex-direction: column;
      }
    }
  }
}
</style>

<style lang="scss">
.landing {
  .social-sharing {
    position: absolute;
    left: 20px;
    top: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    span {
      margin: 20px;
      display: inline-block;
      cursor: pointer;
      svg {
        height: 16px;
      }
      &:hover {
        svg {
          path {
            fill-opacity: 0.8;
          }
        }
      }
    }
    &.mobile {
      position: relative;
      width: 100%;
      flex-direction: row;
      left: 0;
    }
  }
}
</style>
